"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStringValueFromGenericInput = getStringValueFromGenericInput;
exports.getNumberValueFromGenericInput = getNumberValueFromGenericInput;

var getNumber = function getNumber(number) {
  return parseInt(number, 10);
};

function getDefaultedValue(defaultVal, transformFn) {
  return function (value) {
    if (!value) {
      return defaultVal;
    }

    return transformFn ? transformFn(value) : value;
  };
}

function getValueFromGenericInput(inputValue, defaultValue, transformFn) {
  var getValue = getDefaultedValue(defaultValue, transformFn);

  if (!inputValue) {
    return getValue(inputValue);
  }

  if (typeof inputValue === 'number' || typeof inputValue === 'string') {
    return getValue(inputValue);
  }

  if (inputValue.target) {
    // $FlowFixMe
    return getValue(inputValue.target.value);
  }

  if ('value' in inputValue) {
    return getValue(inputValue.value);
  }

  return getValue(inputValue);
}

function getStringValueFromGenericInput(inputValue) {
  return getValueFromGenericInput(inputValue, '');
}

function getNumberValueFromGenericInput(inputValue) {
  return getValueFromGenericInput(inputValue, 0, getNumber);
}